export const menuItems = [
    {
        id: 100,
        label: 'menu.dashboards',
        isTitle: true,
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 110,
        label: 'menu.dashboard',
        icon: 'mdi-monitor-dashboard',
        link: '/dashboard',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 200,
        label: 'menu.manage',
        isTitle: true,
        authorization: ['ADMIN', 'HQ']
    },
    {
        id: 210,
        label: 'menu.managerAccount',
        icon: 'mdi-account-check-outline',
        link: '/manager/list',
        authorization: ['ADMIN', 'HQ']
    },
    {
        id: 220,
        label: 'menu.headquarters',
        icon: 'mdi-home-circle-outline',
        link: '/hq/list',
        authorization: ['ADMIN', 'HQ']
    },
    {
        id: 300,
        label: 'menu.charge',
        isTitle: true,
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 310,
        label: 'menu.chargePlace',
        icon: 'mdi-office-building-outline',
        link: '/charge/place/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 320,
        label: 'menu.chargePoint',
        icon: 'mdi-ev-station',
        link: '/charge/point/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 330,
        label: 'menu.chargePrice',
        icon: 'mdi-cash',
        link: '/charge/price/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
/*
    {
        id: 340,
        label: 'menu.chargeOutput',
        icon: 'mdi-cog-transfer-outline',
        link: '/charge/output/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
*/
    {
        id: 350,
        label: 'menu.plan',
        icon: 'mdi-calendar-account-outline',
        authorization: ['ADMIN', 'HQ', 'CP'],
        subItems: [
            {
                id: 351,
                label: 'menu.memberPlan',
                link: '/plan/member/list',
                authorization: ['ADMIN'],
                parentId: 350
            },
            {
                id: 352,
                label: 'menu.businessPlan',
                link: '/plan/business/list',
                authorization: ['ADMIN', 'HQ', 'CP'],
                parentId: 350
            }
        ]
    },
    {
        id: 360,
        label: 'menu.chargeHistory',
        icon: 'mdi-credit-card-clock-outline',
        link: '/charge/history/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    {
        id: 370,
        label: 'menu.planHistory',
        icon: 'mdi-calendar-clock',
        link: '/plan/history/list',
        authorization: ['ADMIN']
    },
    {
        id: 400,
        label: 'menu.settlement',
        isTitle: true,
        authorization: ['ADMIN', 'HQ', 'CP']
    },
    // TODO : 정산관리 기획 후 재설정 필요
    {
        id: 410,
        label: 'menu.manageSettlement',
        icon: 'mdi-progress-question',
        authorization: ['ADMIN', 'HQ', 'CP'],
        subItems: [
            {
              id: 411,
              label: 'menu.manageSettlement',
              link: '/settlement/list',
              authorization: ['ADMIN'],
              parentId: 410
            },
            {
                id: 412,
                label: 'menu.settlementReport',
                link: '/settlement/report/list',
                authorization: ['ADMIN', 'HQ', 'CP'],
                parentId: 410
            },
            {
                id: 413,
                label: 'menu.settlementUltraPlan',
                link: '/settlement/ultraplan/list',
                authorization: ['ADMIN'],
                parentId: 410
            },
            /*{
                id: 412,
                label: 'menu.manageSettlementHQ',
                link: '/settlement/HQ/list',
                authorization: ['ADMIN', 'HQ'],
                parentId: 410
            },
            {
                id: 413,
                label: 'menu.manageSettlementCP',
                link: '/settlement/CP/list',
                authorization: ['ADMIN', 'HQ', 'CP'],
                parentId: 410
            }*/
        ]
    },
    /*{
        id: 410,
        label: 'menu.manageSettlement',
        icon: 'mdi-progress-question',
        authorization: ['ADMIN', 'HQ', 'CP'],
        link: '/settlement/HQ/list',
    },*/
/*
    {
        id: 420,
        label: 'menu.managePoint',
        icon: 'mdi-file-powerpoint-box-outline',
        link: '/point/list',
        authorization: ['ADMIN', 'HQ', 'CP']
    },
*/
    {
        id: 500,
        label: 'menu.app',
        isTitle: true,
        authorization: ['ADMIN', 'HQ']
    },
    {
        id: 510,
        label: 'menu.manageUser',
        icon: 'mdi-account-multiple',
        link: '/app/member/list',
        authorization: ['ADMIN']
    },
    {
        id: 520,
        label: 'menu.manageAd',
        icon: 'mdi-television',
        link: '/app/ad/list',
        authorization: ['ADMIN', 'HQ']
    },
    {
        id: 900,
        label: 'menu.system',
        isTitle: true,
        authorization: ['ADMIN']
    },
    {
        id: 910,
        label: 'menu.notice',
        icon: 'mdi-information-outline',
        link: '/system/notice/list',
        authorization: ['ADMIN']
    },
    {
        id: 920,
        label: 'menu.termsPolicy',
        icon: 'mdi-file-document-edit-outline',
        link: '/system/terms/list',
        authorization: ['ADMIN']
    },
    {
        id: 930,
        label: 'menu.systemNotification',
        icon: 'mdi-post-outline',
        link: '/system/notification/list',
        authorization: ['ADMIN']
    },
    {
        id: 1000,
        label: 'menu.ocpp',
        isTitle: true,
        authorization: ['ADMIN'],
        email: 'admin@i-on.net'
    },
    {
        id: 1010,
        label: 'menu.ocpp16',
        icon: 'mdi-ev-station',
        authorization: ['ADMIN'],
        email: 'admin@i-on.net',
        subItems: [
            {
                id: 1011,
                label: 'menu.operations',
                link: '/ocpp/operations',
                authorization: ['ADMIN'],
                email: 'admin@i-on.net',
                parentId: 1010
            }
        ]
    }
];
